<template>
  <div class="page-wrap" v-if="isShow" @click.self="hide();$emit('cancel')">
    <transition name="page-move">
      <div class="filter-wrap" v-if="infoShow">
        <div class="check-group-box">
          <p class="title">拜访状态</p>
          <div class="li-box flex-wrap">
            <button type="button" :class="[curParams.visitStatus === '' ? 'selected':'']" @click="coverClickHandle()">全部</button>
            <button type="button" :class="[curParams.visitStatus === true ? 'selected':'']" @click="coverClickHandle(true)">已拜访</button>
            <button type="button" :class="[curParams.visitStatus === false ? 'selected':'']" @click="coverClickHandle(false)">未拜访</button>
          </div>
        </div>
        <div class="check-group-box">
          <p class="title">终端类型</p>
          <div class="li-box float-box">
            <button v-for="(clientType,index) in clientTypes" type="button" :class="[curParams.clientType.includes(clientType.name) ? 'selected':'']" @click="typeClickHandle(clientType.name)" :key="index">{{ clientType.name }}</button>
          </div>
        </div>
        <!-- <div class="check-group-box">
          <p class="title">经营状态</p>
          <div class="li-box flex-wrap">
            <button type="button" :class="[curParams.businessStatus === '' ? 'selected':'']" @click="businessStatusClickHandle()">全部</button>
            <button type="button" :class="[curParams.businessStatus === true ? 'selected':'']" @click="businessStatusClickHandle(true)">正常</button>
            <button type="button" :class="[curParams.businessStatus === false ? 'selected':'']" @click="businessStatusClickHandle(false)">停业</button>
          </div>
        </div> -->
        <!--iphone X小黑条占位-->
        <div class="home-indicator"></div>
        <!--底部按钮区域-->
        <div class="btn-box flex-wrap">
          <button type="button" class="cancel" @click="hide();$emit('cancel')">取消</button>
          <button type="button" class="sure" @click="sureHandle()">确认</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ClientFilter',
  props: {
    // 已选参数
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isShow: false, // 遮盖层整个页面的显示
      infoShow: false, // 带动效的页面内容数据显示
      curParams: {
        clientType: '', // 终端类型
        // cover: '', // 是否覆盖 true false
        visitStatus: '' // 是否拜访 true false
        // businessStatus: '全部' // 经营状态
      },
      clientTypes: [
        {
          name: '单体药店'
        },
        {
          name: '连锁门店'
        },
        {
          name: '连锁总部'
        },
        {
          name: '诊所'
        }
      ]
      // clientTypes: {
      //   10101: '单体药店',
      //   10102: '连锁门店',
      //   10103: '连锁总部',
      //   20101: '诊所'
      // },
    }
  },
  computed: {
  },
  beforeMount () {
    this.clientTypeList()
  },
  methods: {
    show () {
      this.curParams.clientType = this.params.clientType ? this.params.clientType.split(',') : []
      this.curParams.visitStatus = (this.params.visitStatus === true || this.params.visitStatus === false) ? this.params.visitStatus : ''
      // this.curParams.businessStatus = (this.params.businessStatus === true || this.params.businessStatus === false) ? this.params.businessStatus : ''
      this.isShow = true
      const _this = this
      setTimeout(function () {
        _this.infoShow = true
      }, 10)
    },
    hide () {
      this.infoShow = false
      this.isShow = false
    },
    clientTypeList () {
      const list = {}
      this.$store.commit('clientTypesChange', list)
    },
    // 终端类型点击事件
    typeClickHandle (type) {
      if (this.curParams.clientType.includes(type)) {
        this.curParams.clientType.splice(this.curParams.clientType.indexOf(type), 1)
      } else {
        this.curParams.clientType.push(type)
      }
    },
    // 是否拜访点击事件
    coverClickHandle (type = '') {
      if (this.curParams.visitStatus === type) {
        this.curParams.visitStatus = ''
      } else {
        this.curParams.visitStatus = type
      }
    },
    // 经营状态点击事件
    // businessStatusClickHandle (type = '') {
    //   if (this.curParams.businessStatus === type) {
    //     this.curParams.businessStatus = ''
    //   } else {
    //     this.curParams.businessStatus = type
    //   }
    // },
    // 确认事件
    sureHandle () {
      this.curParams.clientType = this.curParams.clientType.join(',')
      this.hide()
      this.$emit('filterHandle', this.curParams)
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl";
    .page-wrap{
        position fixed
        width 100%
        height 100%
        top: 0
        left 0
        background rgba(0,0,0,.6)
        z-index 91
    }
    .filter-wrap{
        width 610px
        height 100%
        padding-bottom 84px
        background #fff
        transition: transform .3s
        position absolute
        right 0
        top 0
        overflow auto
    }
    .check-group-box{
        margin 0 32px
        border-bottom 1px solid $border-color
        .title{
            font-weight bold
            line-height 64px
            padding-top 24px
            font-size $font-XXL
        }
        .li-box{
            &.flex-wrap{
                height 88px
                align-items center
            }
            button{
                padding 0 16px
                height 40px
                border 1px solid $color-font-lighter
                font-size $font-M
                color $color-font-lighter
                margin-right 30px
                border-radius 3px
                &.selected{
                    color $color-main
                    border-color $color-main
                }
                &:last-child{
                    margin-right 0
                }
            }
            &.float-box{
                width 578px
                padding-top 24px
                overflow hidden
                button{
                    float left
                    margin-bottom 24px
                }
            }
            .month-label{
                font-size $font-L
                .sprite{
                    transform translate(0,4px)
                    margin-left 13px
                }
            }
        }
        .goods-search{
            height 64px
            margin 24px 0
        }
        &.hasList{
            margin 0 0 8px
            padding 0 32px
            border-bottom none
            // box-shadow 0 5px 10px rgba(0,0,0,.1)
        }
    }
    .goods-list{
        max-height 704px
        padding-left 32px
        overflow auto
        .goods-li{
            height 88px
            padding-right 29px
            align-items center
            justify-content space-between
            border-bottom 1px solid $border-color
            word-break break-all
            .name{
                font-size $font-L
                line-height 36px
                max-width 480px
            }
            &.selected{
                .name{
                    color $color-main
                }
                .sprite{
                    display inline-block
                }
            }
        }
    }
    .btn-box{
        width 610px
        height 88px
        box-sizing content-box
        align-items center
        justify-content space-between
        position fixed
        right 0
        bottom 0
        background $color-white
        padding-bottom env(safe-area-inset-bottom)
        button{
            height 100%
            width 50%
            font-size $font-XXXL
            &.cancel{
                border-top 1px solid $border-color
                color $color-font
                background $color-white
            }
            &.sure{
                color $color-white
                background $color-main
            }
        }
    }

    // 过渡效果
    .page-move-enter, .page-move-leave-active
        transform: translate(100%, 0%)
    .page-move-enter-active, .page-move-leave-active
        transition: transform .6s
</style>
<style scoped>
    @-moz-document url-prefix(){
        .check-group-box .li-box button{
            line-height: 40px;
        }
    }

</style>
